import { render } from "./Order_add.vue?vue&type=template&id=b29bec4a"
import script from "./Order_add.vue?vue&type=script&lang=js"
export * from "./Order_add.vue?vue&type=script&lang=js"

import "./Order_add.vue?vue&type=style&index=0&id=b29bec4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__